// extracted by mini-css-extract-plugin
export default {"errorMain":"Error404_errorMain__jkCR9","errorImage":"Error404_errorImage__TCcG+","errorMainContent":"Error404_errorMainContent__HWvKn","errorButton":"Error404_errorButton__fOwi6"};